module.exports = __webpack_public_path__ + "static/media/lauren.2bea4058.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/lauren.png
// module id = 181
// module chunks = 0